import React from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';

interface ThankYouModalProps {
  isOpen: boolean;
  onClose: () => void;
  isAuthenticated: boolean;
  noteId?: string;
}

const ThankYouModal: React.FC<ThankYouModalProps> = ({
  isOpen,
  onClose,
  isAuthenticated,
  noteId
}) => {
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  const handleCreateAccount = () => {
    // Store noteId in localStorage for claiming after OAuth
    if (noteId) {
      localStorage.setItem('pendingNoteId', noteId);
    }
    // Redirect to OAuth flow on the API host (same URL AuthContext.login uses)
    window.location.href = `${API_BASE_URL}/auth/google`;
  };

  const handleReturnHome = () => {
    onClose();
    navigate('/');
  };

  const handleViewMyNotes = () => {
    onClose();
    navigate('/my-notes');
  };

  return (
    <div
      className="modal d-block"
      tabIndex={-1}
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="thank-you-modal-title"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: '2px solid #7FA99B' }}>
            <h5 className="modal-title" id="thank-you-modal-title" style={{ color: '#1C2826' }}>
              Thank you for writing a note
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <p style={{ color: '#556862' }}>
              Your message is on its way. Our team will review it soon, and then it could reach
              someone who needs to hear exactly these words today. That matters more than you know.
            </p>
          </div>
          <div className="modal-footer" style={{ borderTop: 'none' }}>
            {isAuthenticated ? (
              <>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={onClose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={handleViewMyNotes}
                  style={{
                    backgroundColor: '#7FA99B',
                    borderColor: '#7FA99B',
                    color: 'white'
                  }}
                >
                  View my notes
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleReturnHome}
                >
                  Return home
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={handleCreateAccount}
                  style={{
                    backgroundColor: '#7FA99B',
                    borderColor: '#7FA99B',
                    color: 'white'
                  }}
                >
                  Create an account to track your notes
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;
